import { message } from 'antd';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { logOut } from '../authentication/actionCreator';
import { getItem } from '../../utility/localStorageControl';

const {
  taskAddBegin,
  taskAddSuccess,
  taskAddErr,

  taskReadBegin,
  taskReadSuccess,
  taskReadErr,

  getTaskByUserReadBegin,
  getTaskByUserReadSuccess,
  getTaskByUserReadErr,

  singleTaskReadBegin,
  singleTaskReadSuccess,
  singleTaskReadErr,

  assignedTasksReadBegin,
  assignedTasksReadSuccess,
  assignedTasksReadErr,

  assignTaskToPersonBegin,
  assignTaskToPersonSuccess,
  assignTaskToPersonErr,

  taskUpdateSuccess,
  taskUpdateErr,
  taskUpdateBegin,


  taskInfoReadBegin,
  taskInfoReadSuccess,
  taskInfoReadErr,

} = actions;

const taskDataSubmit = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(taskAddBegin());
      const response = await DataService.post('/tasks/create', data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(taskAddSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(taskAddSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(taskAddSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(taskAddErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const assignTaskToPersonDataSubmit = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(assignTaskToPersonBegin());
      const response = await DataService.post('/tasks/assign-tasks-to-persons', data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(assignTaskToPersonSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(assignTaskToPersonSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(assignTaskToPersonSuccess(null));
          dispatch(logOut());
        }
      }
    } catch (err) {
      await dispatch(assignTaskToPersonErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const taskDataRead = () => {
  return async (dispatch) => {
    try {
      await dispatch(taskReadBegin());
      const response = await DataService.get(`/tasks`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(taskReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(taskReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(taskReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(taskReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const taskInfoRead = () => {
  return async (dispatch) => {
    try {
      await dispatch(taskInfoReadBegin());
      const response = await DataService.get(`/tasks/taskInfos`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(taskInfoReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(taskInfoReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(taskInfoReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(taskInfoReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const getTaskByUserDataRead = (id) => {
  return async (dispatch) => {
    try {
      await dispatch(getTaskByUserReadBegin());
      const response = await DataService.get(`/tasks/employee-tasks/${id}`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(getTaskByUserReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(getTaskByUserReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(getTaskByUserReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(getTaskByUserReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const singleTaskDataRead = (id) => {
  return async (dispatch) => {
    try {
      await dispatch(singleTaskReadBegin());
      const response = await DataService.get(`/tasks/single-task/${id}`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(singleTaskReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(singleTaskReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(singleTaskReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(singleTaskReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const assignedTasksDataRead = () => {
  return async (dispatch) => {
    try {
      await dispatch(assignedTasksReadBegin());
      const response = await DataService.get(`/tasks/assigned/tasks-to-persons`);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(assignedTasksReadSuccess(response.data.payload));
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(assignedTasksReadSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(assignedTasksReadSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(assignedTasksReadErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

const taskDataUpdate = (data) => {
  return async (dispatch) => {
    try {
      await dispatch(taskUpdateBegin());
      const response = await DataService.put(`/tasks/update`, data);
      const token = getItem('access_token');
      if (token && response !== null && response.data.Error === false) {
        await dispatch(taskUpdateSuccess(response.data));
        message.success(response.data.message);
      } else if (token && response !== null && response.data.Error === true && response.data.statusCode !== 401) {
        message.error(response.data.message);
        await dispatch(taskUpdateSuccess(null));
      }
      else {
        if (response.data.Error === true && response.data.statusCode === 401) {
          message.error(response.data.message);
          await dispatch(taskUpdateSuccess(null));
          dispatch(logOut())
        }
      }
    } catch (err) {
      await dispatch(taskUpdateErr(err));
      if (err.message === "Network Error") {
        message.error("Server is down, please contact developer team")
        dispatch(logOut())
      } else {
        message.error(err.message);
      }
    }
  };
};

export {
  taskDataRead,
  taskDataSubmit,
  taskDataUpdate,
  assignedTasksDataRead,
  singleTaskDataRead,
  assignTaskToPersonDataSubmit,
  getTaskByUserDataRead,
  taskInfoRead
};
